<template>
  <q-page-container>
    <q-page class="">
      <div class="title-page">Dados da solicitação</div>
      <section class="section-service col-12">
        <q-option-group
          hidden
          v-model="panel"
          inline
          :options="[
            { label: 'Tab-1', value: 'tab-1' },
            { label: 'Tab-2', value: 'tab-2' },
          ]"
        />
        <q-tab-panels v-model="panel" class="panel-services">
          <q-tab-panel
            name="tab-1"
            class="col-12 row items-center justify-center"
          >
            <q-form ref="formtab1">
              <div class="group-input col-12 row q-mt-sm">
                <label for="type-os">Tipo de OS</label>
                <q-select
                  id="type-os"
                  class="col-12 q-mt-sm form-tabulacao"
                  outlined
                  dense
                  ref="typeOSRef"
                  v-model="requestData.typeOS"
                  color="red-9"
                  @filter="getTypeOsByClassification"
                  use-input
                  hide-selected
                  fill-input
                  input-debounce="0"
                  :options="optionsTypeOSByClassification"
                  option-value="value"
                  option-label="text"
                  bg-color="white"
                  :rules="[(val) => !!val || 'Campo Obrigatório']"
                  lazy-rules
                />
              </div>
              <div
                class="group-input col-12 row q-mt-sm"
                v-if="inputsDisabledMenagement.osInfoNumber"
              >
                <label for="os_install_number">Informe o número da OS</label>
                <q-input
                  id="os_install_number"
                  ref="osInstallNumberRef"
                  v-model="requestData.osNumber"
                  class="col-12 q-mt-sm"
                  bg-color="white"
                  maxlength="10"
                  color="red-9"
                  dense
                  outlined
                  type="text"
                  unmasked-value
                  placeholder="0000000000"
                  :rules="[(val) => !!val || 'Campo Obrigatório']"
                  lazy-rules
                />
              </div>
              <div
                class="group-input col-12 column q-mt-lg"
                v-if="isTerminalHandling(typeAttendance)"
              >
                <label for="write-off-code">Tipo de agendamento</label>
                <div class="flex row justify-around">
                  <q-radio
                    v-model="requestData.movimentscheduling"
                    keep-color
                    size="lg"
                    :val="1"
                    label="Realizar agendamento"
                    color="red-6"
                    :disable="inputsDisabledMenagement.movimentTerminal"
                    @update:model-value="isEnableByMovimentTerminal(false)"
                  />
                  <q-radio
                    v-model="requestData.movimentscheduling"
                    keep-color
                    size="lg"
                    :val="0"
                    label="Abertura imediata"
                    color="red-6"
                    :disable="inputsDisabledMenagement.movimentTerminal"
                    @update:model-value="isEnableByMovimentTerminal(true)"
                  />
                </div>
              </div>

              <div class="group-input col-12 column q-mt-lg" v-else>
                <label for="write-off-code"
                  >Houve movimentação de terminal</label
                >

                <div class="flex row justify-around">
                  <q-radio
                    v-model="requestData.movimentTerminal"
                    keep-color
                    size="lg"
                    :val="1"
                    label="Sim"
                    color="red-6"
                    :disable="inputsDisabledMenagement.movimentTerminal"
                    @update:model-value="isEnableByMovimentTerminal(false)"
                  />
                  <q-radio
                    v-model="requestData.movimentTerminal"
                    keep-color
                    size="lg"
                    :val="0"
                    label="Não"
                    color="red-6"
                    :disable="inputsDisabledMenagement.movimentTerminal"
                    @update:model-value="isEnableByMovimentTerminal(true)"
                  />
                </div>
              </div>
              <div
                class="group-input col-12 column q-mt-lg"
                v-if="isContainsTerminalHandlingToo(typeAttendance)"
              >
                <label for="write-off-code"
                  >Houve movimentação de terminal</label
                >
                <div class="flex row justify-around">
                  <q-radio
                    v-model="requestData.movimentTerminal"
                    keep-color
                    size="lg"
                    :val="1"
                    label="Sim"
                    color="red-6"
                    @update:model-value="handleEnableFields(false)"
                  />
                  <q-radio
                    v-model="requestData.movimentTerminal"
                    keep-color
                    size="lg"
                    :val="0"
                    label="Não"
                    color="red-6"
                    @update:model-value="handleEnableFields(true)"
                  />
                </div>
              </div>

              <div class="column" v-if="toogleFormByScheduleType()">
                <div class="group-input col-12 row q-mt-sm">
                  <label for="os_action">Ação</label>
                  <q-select
                    id="os_action"
                    class="col-12 q-mt-sm form-tabulacao"
                    outlined
                    dense
                    ref="osActionRef"
                    v-model="requestData.action"
                    emit-value
                    color="red-9"
                    use-input
                    hide-selected
                    fill-input
                    input-debounce="0"
                    :disable="inputsDisabledMenagement.action"
                    :options="optionsActionOs"
                    @update:model-value="
                      () => $emit('getTypeOsClassification', requestData.action)
                    "
                    map-options
                    option-value="id_acao"
                    option-label="desc_acao"
                    bg-color="white"
                    :rules="[(val) => !!val || 'Campo Obrigatório']"
                    lazy-rules
                  />
                </div>
                <div class="group-input col-12 row q-mt-sm">
                  <label for="type-os">Estado</label>
                  <q-select
                    id="state-os"
                    class="col-12 q-mt-sm form-tabulacao"
                    outlined
                    dense
                    ref="stateOSRef"
                    v-model="requestData.state"
                    color="red-9"
                    use-input
                    hide-selected
                    fill-input
                    input-debounce="0"
                    :options="optionsStateEquipaments"
                    emit-value
                    map-options
                    :disable="inputsDisabledMenagement.state"
                    option-value="id_estado_equipamento"
                    option-label="desc_estado_equipamento"
                    bg-color="white"
                    :rules="[(val) => !!val || 'Campo Obrigatório']"
                    lazy-rules
                  />
                </div>
                <div class="group-input col-12 row q-mt-lg">
                  <label for="write-off-code">Código de Baixa</label>
                  <q-select
                    id="write-off-code"
                    class="col-12 q-mt-sm"
                    outlined
                    dense
                    ref="writeOffCodeRef"
                    v-model="requestData.writeOffCode"
                    color="red-9"
                    @filter="filterWriteOffCode"
                    use-input
                    hide-selected
                    fill-input
                    input-debounce="0"
                    :options="optionsItens.optionsWriteOffCode"
                    :disable="inputsDisabledMenagement.waterMark"
                    option-value="value"
                    option-label="text"
                    bg-color="white"
                    :rules="[(val) => !!val || 'Campo Obrigatório']"
                    lazy-rules
                  />
                </div>
              </div>

              <div class="column" v-else>
                <!-- <div class="col-12 q-mt-lg">
                  <label for="start">Opção 1</label>
                  <q-input
                    id="start"
                    v-model="requestData.option1"
                    bg-color="white"
                    class="col-12 q-mt-sm"
                    color="red-9"
                    type="datetime-local"
                    dense
                    outlined
                    :rules="[(val) => !!val || 'Campo Obrigatório']"
                    lazy-rules
                  />
                </div>

                <div class="col-12 q-mt-lg">
                  <label for="conclusion_time">Opção 2</label>
                  <q-input
                    id="conclusion_time"
                    v-model="requestData.option2"
                    bg-color="white"
                    class="col-12 q-mt-sm"
                    color="red-9"
                    type="datetime-local"
                    dense
                    outlined
                    :rules="[(val) => !!val || 'Campo Obrigatório']"
                    lazy-rules
                  />
                </div> -->
                <div class="group-input col-12 row q-mt-sm">
                  <label for="type-os">Opção 1</label>
                  <div
                    class="group-input col-12 row q-mt-sm flex justify-around"
                  >
                    <q-select
                      id="type-os"
                      class="col-5 q-mt-sm form-tabulacao"
                      outlined
                      dense
                      ref="typeOSRef"
                      v-model="requestData.option1"
                      color="red-9"
                      use-input
                      hide-selected
                      fill-input
                      input-debounce="0"
                      :options="datesHoursAvailableForSelection.date"
                      option-value="value"
                      option-label="text"
                      bg-color="white"
                      lazy-rules
                      :rules="[(val) => !!val || 'Campo Obrigatório']"
                    />

                    <q-select
                      id="type-os"
                      class="col-5 q-mt-sm form-tabulacao"
                      outlined
                      dense
                      ref="typeOSRef"
                      v-model="requestData.hourOption1"
                      color="red-9"
                      use-input
                      hide-selected
                      fill-input
                      input-debounce="0"
                      :options="datesHoursAvailableForSelection.hour"
                      option-value="value"
                      option-label="text"
                      bg-color="white"
                      lazy-rules
                      :rules="[(val) => !!val || 'Campo Obrigatório']"
                    />
                  </div>
                </div>

                <div class="group-input col-12 row q-mt-sm">
                  <label for="type-os">Opção 2</label>
                  <div
                    class="group-input col-12 row q-mt-sm flex justify-around"
                  >
                    <q-select
                      id="type-os"
                      class="col-5 q-mt-sm form-tabulacao"
                      outlined
                      dense
                      ref="typeOSRef"
                      v-model="requestData.option2"
                      color="red-9"
                      use-input
                      hide-selected
                      fill-input
                      input-debounce="0"
                      :options="datesHoursAvailableForSelection.date"
                      option-value="value"
                      option-label="text"
                      bg-color="white"
                      lazy-rules
                      :rules="[(val) => !!val || 'Campo Obrigatório']"
                    />

                    <q-select
                      id="type-os"
                      class="col-5 q-mt-sm form-tabulacao"
                      outlined
                      dense
                      ref="typeOSRef"
                      v-model="requestData.hourOption2"
                      color="red-9"
                      use-input
                      hide-selected
                      fill-input
                      input-debounce="0"
                      :options="datesHoursAvailableForSelection.hour"
                      option-value="value"
                      option-label="text"
                      bg-color="white"
                      lazy-rules
                      :rules="[(val) => !!val || 'Campo Obrigatório']"
                    />
                  </div>
                </div>
                <div class="group-input col-12 row q-mt-sm">
                  <label for="type-os"
                    >Qual a quantidade de OS Instalar Cabeamento streaming
                    deverá ser gerada?</label
                  >
                  <q-input
                    v-model="requestData.osQuantity"
                    bg-color="white"
                    class="col-12 q-mt-sm"
                    color="red-9"
                    type="number"
                    :min="1"
                    :max="3"
                    dense
                    outlined
                    :rules="[(val) => val < 4 || 'Número valido entre 1 e 8']"
                    lazy-rules
                  />
                </div>
              </div>

              <div class="group-input col-12 row q-mt-md">
                <label for="observation">Observação</label>
                <div class="col-12 row flex justify-around">
                  <q-input
                    v-model="requestData.observation"
                    class="col-12 q-mt-sm"
                    bg-color="white"
                    color="red-9"
                    maxlength="120"
                    outlined
                    autogrow
                    :rules="[(val) => !!val || 'Campo Obrigatório']"
                    lazy-rules
                  />
                </div>
              </div>
            </q-form>
          </q-tab-panel>

          <q-tab-panel
            name="tab-2"
            class="col-12 row items-center justify-center"
          >
            <q-form ref="formtab2">
              <div class="group-input col-12 row q-mt-sm">
                <label for="os_install_number"
                  >Número equipamento instalado</label
                >
                <q-input
                  id="os_install_number"
                  ref="osInstallNumberRef"
                  v-model="requestData.equipamentNumberInstall"
                  class="col-12 q-mt-sm"
                  bg-color="white"
                  maxlength="20"
                  color="red-9"
                  dense
                  outlined
                  type="text"
                  unmasked-value
                  placeholder="0000000000"
                  :rules="[(val) => !!val || 'Campo Obrigatório']"
                  lazy-rules
                  :disable="isBLockedNumEquipament(typeAttendance)"
                  @blur="
                    openDialogEquipament(
                      'Confirma numeração do equipamento instalado?'
                    )
                  "
                />
              </div>

              <div
                class="group-input col-12 row q-mt-sm"
                v-if="inputsDisabledMenagement.isShowUninstallEquipment"
              >
                <label for="os_install_number"
                  >Número equipamento desinstalado</label
                >
                <q-input
                  id="os_install_number"
                  ref="osInstallNumberRef"
                  v-model="requestData.equipamentNumberUninstall"
                  class="col-12 q-mt-sm"
                  bg-color="white"
                  maxlength="20"
                  color="red-9"
                  dense
                  outlined
                  type="text"
                  unmasked-value
                  placeholder="0000000000"
                  :rules="[
                    (val) =>
                      !!val ||
                      isRequiredNumEquipamentUnistall() ||
                      'Campo Obrigatório',
                  ]"
                  lazy-rules
                  :disable="isBLockedNumEquipament(typeAttendance)"
                  @blur="
                    openDialogEquipament(
                      'Confirma numeração do equipamento desinstalado?'
                    )
                  "
                />
              </div>

              <div class="group-input col-12 row q-mt-md">
                <label for="type-os"
                  >Foi necessário movimentar o smartcard?</label
                >
                <div class="col-12 row flex justify-around">
                  <q-radio
                    keep-color
                    v-model="requestData.IsDecoderComum"
                    :val="1"
                    size="lg"
                    label="Sim"
                    color="red-6"
                    :disable="inputsDisabledMenagement.isDisabledSmartCard"
                  />
                  <q-radio
                    keep-color
                    v-model="requestData.IsDecoderComum"
                    :val="0"
                    size="lg"
                    label="Não"
                    color="red-6"
                    :disable="inputsDisabledMenagement.isDisabledSmartCard"
                  />
                </div>
              </div>

              <div
                class="group-input col-12 row q-mt-sm"
                v-if="requestData.IsDecoderComum == 1"
              >
                <label for="os_number"
                  >Informe o número do SMARTCARD instalado</label
                >
                <q-input
                  id="os_number"
                  ref="cardNumberRef"
                  v-model="requestData.cardNumberInstaled"
                  class="col-12 q-mt-sm"
                  bg-color="white"
                  maxlength="12"
                  color="red-9"
                  dense
                  outlined
                  unmasked-value
                  type="text"
                  placeholder="0000000000"
                  lazy-rules
                  :rules="[
                    (val) =>
                      !!val ||
                      requestData.IsDecoderComum == 1 ||
                      'Campo Obrigatório',
                  ]"
                />
                <!-- -->
              </div>
              <div
                class="group-input col-12 row q-mt-sm"
                v-if="
                  requestData.IsDecoderComum == 1 &&
                  inputsDisabledMenagement.isShowUninstallSmartCard
                "
              >
                <label for="os_number"
                  >Informe o número do SMARTCARD desinstalado</label
                >
                <q-input
                  id="os_number"
                  ref="cardNumberRef"
                  v-model="requestData.cardNumberUninstall"
                  class="col-12 q-mt-sm"
                  bg-color="white"
                  maxlength="12"
                  color="red-9"
                  dense
                  outlined
                  unmasked-value
                  type="text"
                  placeholder="0000000000"
                  lazy-rules
                />
                <!-- :rules="[
                    (val) =>
                      !!val ||
                      // requestData.IsDecoderComum == 1 ||
                      'Campo Obrigatório',
                  ]" -->
              </div>
            </q-form>
          </q-tab-panel>
        </q-tab-panels>
        <section>
          <div>
            <q-footer>
              <q-toolbar elevated>
                <div
                  class="flex col-12 row items-center justify-between"
                  v-if="isShowProgessBar()"
                >
                  <div
                    class="col-8 div-progress q-pa-sm justify-center flex items-center"
                  >
                    <q-linear-progress
                      size="md"
                      :value="progressBar"
                      color="red-9"
                      rounded
                    />
                  </div>
                  <div
                    class="col-2 div-btn-next justify-center flex items-center"
                  >
                    <q-btn
                      round
                      color="red-9"
                      @click="addValueBarProgressAndAlterTab()"
                      icon="arrow_forward"
                    />
                  </div>
                </div>
                <div
                  class="flex col-12 row items-center justify-between"
                  v-else
                >
                  <div class="col-4 justify-center flex items-center">
                    <q-btn
                      unelevated
                      outline
                      rounded
                      color="red-9"
                      @click="$emit('removeEdit')"
                      label="Cancelar"
                    />
                  </div>
                  <div class="col-4 justify-center flex items-center">
                    <q-btn
                      unelevated
                      rounded
                      color="red-9"
                      @click="validateForm()"
                      label="Concluir"
                    />
                  </div>
                </div>
              </q-toolbar>
            </q-footer>
          </div>
        </section>
      </section>
    </q-page>
  </q-page-container>
</template>

<script>
import DateTimePicker from "@/components/DateTimePicker";
import SelectCheckbox from "@/components/SelectCheckbox";
import { showNotifyError } from "@/helpers/notifyHelper";
import { TROCA_CONF_EQTO_STREAMING, VISITA_TECNICA_2 } from "@/utils/constants/typeOs/generateOs";
import moment from "moment";
import { useQuasar } from "quasar";
import { onMounted, reactive, ref } from "vue";

export default {
  name: "FormSolicitation",
  components: {
    SelectCheckbox,
    DateTimePicker,
  },
  props: {
    listWriteOffCode: Array,
    listTypeOS: Array,
    optionsWriteOffCode: Array,
    optionsTypeOS: Array,
    optionsTypeOSByClassification: Array,
    optionsActionOs: Array,
    optionsStateEquipaments: Array,
    itemOsContract: Object,
    typeAttendance: Number,
  },
  emits: [
    "saveSchemaRequest",
    "clearSchemaRequest",
    "removeEdit",
    "getTypeOsClassification",
  ],

  setup(props, { emit }) {
    moment.locale("pt-br");

    const $q = useQuasar();
    const ACTION_INSTALLED_ID = ref(2);
    const ACTION_DEVOLUTION_ID = ref(3);

    const VALUE_MAX_BAR_PROGRESS = 1;

    let panel = ref("tab-1");
    let tabindex = ref(1);
    let progressBar = ref(0.5);

    let requestData = reactive(props.itemOsContract);

    let contract = reactive({
      osRequests: [],
    });
    let confirmationReplicateWriteOffCode = ref(false);
    let modalReplicateWriteOffCode = ref(false);
    let inputsDisabledMenagement = ref({
      movimentTerminal: false,
      action: false,
      state: false,
      waterMark: false,
      osInfoNumber: false,
      canEditEquipment: false,
      isShowUninstallEquipment: true,
      isShowUninstallSmartCard: true,
      osInfoNumber: false,
      isDisabledSmartCard: false,
    });

    let schemaRequest = reactive({
      object_id: "",
      osNumber: "",
      typeOS: "",
      statusOS: 1,
      writeOffCode: "",
      observation: "",
      check: false,
      replicate: false,
      source: "",
      action: 1,
      state: 1,
      equipamentNumberInstall: "",
      equipamentNumberDesinstall: "",
      cardNumberInstaled: "",
      cardNumberUninstalled: "",
    });
    const formtab1 = ref(null);
    const formtab2 = ref(null);

    const listTypeOS = ref([]);
    const listWriteOffCode = ref([]);

    const optionsItens = reactive({
      optionsTypeOS: listTypeOS,
      optionsWriteOffCode: listWriteOffCode,
    });

    const listOfTerminalHandlingIds = [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
    ];
    const listOfContainsTerminalHandlingToo = ["6", "7", "8"];
    const listOfBLockedNumEquipament = ["3"]; //"7" "9"

    const listOfWriteOffCodeAttendanceTrocaTecnica = [530];
    const datesHoursAvailableForSelection = reactive({
      date: [],
      hour: [
        {
          id: 1,
          text: "08h - 12h",
          value: "08 - 12",
        },
        {
          id: 2,
          text: "12h - 15h",
          value: "12 - 15",
        },
        {
          id: 3,
          text: "15h - 18h",
          value: "15 - 18",
        },
      ],
    });

    function setTypeOsByServiceOption() {
      if (props.optionsTypeOSByClassification.length == 1) {
        requestData.typeOS = props.optionsTypeOSByClassification[0];
      }
    }

    function setWriteOffCodeByServiceOption() {
      if (props.typeAttendance == VISITA_TECNICA_2) {
        props.listWriteOffCode.forEach((v) => {
          if (listOfWriteOffCodeAttendanceTrocaTecnica.includes(v.value)) {
            requestData.writeOffCode = v;
          }
        });
      }
    }

    function filterTypeOS(val, update) {
      update(() => {
        const needle = val.toLowerCase();
        optionsItens.optionsTypeOS = props.listTypeOS.filter(
          (v) => v.text.toLowerCase().indexOf(needle) > -1
        );
      });
    }

    function filterWriteOffCode(val, update) {
      update(() => {
        if (props.typeAttendance == VISITA_TECNICA_2) {
          optionsItens.optionsWriteOffCode = props.listWriteOffCode.filter(
            (v) => {
              return listOfWriteOffCodeAttendanceTrocaTecnica.includes(v.value);
            }
          );
        } else {
          const needle = val.toLowerCase();
          optionsItens.optionsWriteOffCode = props.listWriteOffCode.filter(
            (v) => {
              return v.text.toLowerCase().indexOf(needle) > -1;
            }
          );
        }
      });
    }

    function getTypeOsByClassification(val, update) {
      let selectedOption = props.optionsActionOs.find(
        (option) => option.id_acao == requestData.action
      );
      update(() => {
        optionsItens.optionsTypeOS = props.listTypeOS.filter((optionTypeOS) => {
          return (
            optionTypeOS.id_classificacao == selectedOption.id_classificacao
          );
        });
      });
    }

    function _getClassificationTypeName() {
      switch (requestData.action) {
        case 1:
          return "MANUTENÇÃO";
        case 2:
          return "INSTALAÇÃO";
        case 3:
          return "SERVIÇO";
      }
    }

    function isTerminalHandling(id) {
      return listOfTerminalHandlingIds.includes(id);
    }

    function isContainsTerminalHandlingToo(id) {
      return listOfContainsTerminalHandlingToo.includes(id);
    }

    function isBLockedNumEquipament(id) {
      return (
        listOfBLockedNumEquipament.includes(id) ||
        inputsDisabledMenagement.value.canEditEquipment
      );
    }

    function isRequiredNumEquipamentUnistall() {
      if (props.typeAttendance == "7") {
        return requestData.action == 2;
      }
      return false;
    }

    function openDialogEquipament(item, isInstall = true) {
      $q.dialog({
        title: "Confirme a numeração",
        message: item,
        cancel: true,
      })
        .onOk(() => {})
        .onCancel(() => {
          requestData.equipamentNumberInstall = "";
        });
    }

    async function validateForm() {
      let validation = false;

      if (Number(props.typeAttendance) == TROCA_CONF_EQTO_STREAMING && requestData.movimentscheduling == 1) {
        validation = await formtab1.value.validate();
        if (validation) {
          await emitData();
        }
        return validation;
      }

      if (progressBar.value == 1.0) {
        validation = await formtab2.value.validate();
        
        if (props.typeAttendance != "6" || requestData.movimentTerminal != 0) {
          if (requestData.IsDecoderComum == null) {
            showNotifyError('O Smartcard é obrigatório');
            return;
          }
        }

        if (validation) {
          await emitData();
        }
      } else {
        validation = await formtab1.value.validate();
      }
      return validation;
    }

    async function emitData() {
      emit("saveSchemaRequest", requestData);
    }

    function validateSchemaRequest() {
      if (
        requestData.osNumber == "" ||
        requestData.writeOffCode == "" ||
        requestData.typeOS == "" ||
        requestData.observation == ""
      ) {
        showNotifyError('Todos os campos são obrigatórios.');
        return false;
      }
      return true;
    }

    function _changeTab() {
      const VALUE_INCREMENT_ID_TAB = 1;
      const STRING_ID_TAB = "tab-";

      tabindex.value += VALUE_INCREMENT_ID_TAB;
      panel.value = STRING_ID_TAB + tabindex.value;

      return true;
    }

    function toogleFormByScheduleType() {
      if (Number(props.typeAttendance) == TROCA_CONF_EQTO_STREAMING) {
        return requestData.movimentscheduling != 1;
      }
      return true;
    }

    async function addValueBarProgressAndAlterTab() {
      const VALUE_ADD_PROGRESS = 0.5;

      if (
        progressBar.value != VALUE_MAX_BAR_PROGRESS &&
        (await validateForm())
      ) {
        let validateIfChangeTab = _changeTab();

        if (validateIfChangeTab) {
          progressBar.value += VALUE_ADD_PROGRESS;
        }
      }
    }

    function isDisableInputByTypeOs() {
      switch (props.typeAttendance) {
        case "0":
          inputsDisabledMenagement.value.action = true;
          inputsDisabledMenagement.value.state = true;
          return;
        case "1":
          inputsDisabledMenagement.value.movimentTerminal = true;
          inputsDisabledMenagement.value.action = true;
          inputsDisabledMenagement.value.state = true;
          return;
        case "2":
          inputsDisabledMenagement.value.movimentTerminal = true;
          inputsDisabledMenagement.value.action = true;
          inputsDisabledMenagement.value.state = true;
          return;
        case "3":
          inputsDisabledMenagement.value.movimentTerminal = true;
          inputsDisabledMenagement.value.action = true;
          inputsDisabledMenagement.value.state = true;
          return;
        case "4":
          inputsDisabledMenagement.value.movimentTerminal = true;
          inputsDisabledMenagement.value.action = true;
          inputsDisabledMenagement.value.state = true;
          return;
        case "5":
          inputsDisabledMenagement.value.movimentTerminal = true;
          inputsDisabledMenagement.value.action = true;
          inputsDisabledMenagement.value.state = true;
          return;
        case "6":
          inputsDisabledMenagement.value.canEditEquipment = true;
          inputsDisabledMenagement.value.isDisabledSmartCard = true;
          inputsDisabledMenagement.value.movimentTerminal = true;
          inputsDisabledMenagement.value.action = true;
          inputsDisabledMenagement.value.state = true;
          inputsDisabledMenagement.value.osInfoNumber = true;
          inputsDisabledMenagement.value.isShowUninstallEquipment = false;
          inputsDisabledMenagement.value.isShowUninstallSmartCard = false;
          return;
        case "7":
          inputsDisabledMenagement.value.movimentTerminal = true;
          inputsDisabledMenagement.value.state = true;
          inputsDisabledMenagement.value.osInfoNumber = true;
          return;
        case "8":
          inputsDisabledMenagement.value.action = true;
          inputsDisabledMenagement.value.movimentTerminal = true;
          inputsDisabledMenagement.value.state = true;
          inputsDisabledMenagement.value.osInfoNumber = true;
          return;
        case "9":
          inputsDisabledMenagement.value.waterMark = false;
          inputsDisabledMenagement.value.action = true;
          inputsDisabledMenagement.value.state = true;
          return;
        case "10":
          inputsDisabledMenagement.value.movimentTerminal = true;
          inputsDisabledMenagement.value.action = true;
          inputsDisabledMenagement.value.state = true;
          inputsDisabledMenagement.value.waterMark = true;
          return;

        default:
          return;
      }
    }

    function isEnableByMovimentTerminal(state) {
      if (props.typeAttendance == "6" || props.typeAttendance == "7") {
        inputsDisabledMenagement.value.action = state;
        return;
      }
      inputsDisabledMenagement.value.action = state;
      inputsDisabledMenagement.value.state = state;
    }

    function handleEnableFields(state) {
      if (props.typeAttendance == "6") {
        inputsDisabledMenagement.value.canEditEquipment = state;

        inputsDisabledMenagement.value.isDisabledSmartCard = state;
      }

      if (props.typeAttendance == "8") {
        inputsDisabledMenagement.value.action = state;
      }
    }

    function isShowProgessBar() {


      
      if (props.typeAttendance == "9" && panel.value == "tab-1") {
        
        return requestData.movimentscheduling != 1;
      }
    
      
      return panel.value != "tab-2";
    }

    function addDateSchedule() {
      for (let index = 2; index <= 11; index++) {
        datesHoursAvailableForSelection.date.push(
          moment().add(index, "day").endOf("day").format("DD/MM/YYYY")
        );
      }
    }

    onMounted(() => {
      isDisableInputByTypeOs();
      setTypeOsByServiceOption();
      setWriteOffCodeByServiceOption();
      addDateSchedule();
    });

    return {
      ACTION_INSTALLED_ID,
      ACTION_DEVOLUTION_ID,
      inputsDisabledMenagement,
      datesHoursAvailableForSelection,
      panel,
      tabindex,
      progressBar,
      schemaRequest,
      requestData,
      optionsItens,
      formtab1,
      formtab2,
      confirmationReplicateWriteOffCode,
      modalReplicateWriteOffCode,
      validateSchemaRequest,
      filterWriteOffCode,
      filterTypeOS,
      addValueBarProgressAndAlterTab,
      openDialogEquipament,
      validateForm,
      getTypeOsByClassification,
      isEnableByMovimentTerminal,
      handleEnableFields,
      isTerminalHandling,
      isContainsTerminalHandlingToo,
      isBLockedNumEquipament,
      isRequiredNumEquipamentUnistall,
      toogleFormByScheduleType,
      isShowProgessBar,
    };
  },
};
</script>

<style scoped lang="scss">
label {
  font-family: Roboto;
  font-style: normal;
}

.q-page-container {
  padding-bottom: 0px !important;
}

.label-checkbox-confirm {
  font-weight: 500 !important;
  font-size: 12px !important;
  line-height: 14px !important;
  letter-spacing: 0.01em !important;
  color: #999999 !important;
}


footer {
  background: #e5e5e5 !important;
  height: 12vh;

  .q-toolbar {
    height: 12vh;
  }

  .div-progress {
    height: 8vh;
  }

  .div-btn-next {
    height: 8vh;
  }
}

.section-service {
  width: 100%;

  .panel-services {
    background: transparent !important;
    overflow: hidden !important;

    .title-page {
      font-weight: bold;
      font-size: 18px;
      line-height: 19px;
      text-transform: uppercase;
      color: #e2262d;
    }

    .group-input {
      label {
        font-weight: bold;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.4);
      }
    }

    .label-requests-number {
      font-weight: 600;
      font-size: 15px;
      line-height: 20px;
      color: rgba(0, 0, 0, 0.5);
    }

    .label-requests-description {
      font-weight: 500;
      font-size: 12px;
      line-height: 20px;
      color: rgba(0, 0, 0, 0.8);
    }
  }
}
</style>